import * as React from "react";

import { formatCurrencyWithRands } from "app/utils/filters";
import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";
import { formatValue } from "./CardCashbackStrategyContainer";
import Button from "@material-ui/core/Button";

const selectClicked = row => {
  row
    .editCard({
      variables: {
        id: row.cardId,
        cashback_strategy_id: row.id
      }
    })
    .then(row.fetchCardCashbackStrategies);
};

const columnConfigs: ColumnConfig[] = [
  {
    name: "Select",
    alwaysShow: true,
    render: row => (
      <Button
        disabled={row.selected}
        color="primary"
        onClick={() => {
          selectClicked(row);
        }}
      >
        {row.selected ? "x" : "o"}
      </Button>
    )
  },
  {
    name: "Type",
    render: row => row.type
  },
  {
    name: "Description",
    render: row => row.description
  },
  {
    name: "Value",
    render: row => formatValue(row)
  },
  {
    name: "Maximum Cashback Per Payment",
    render: row => formatCurrencyWithRands(row.maximum_cashback_per_payment)
  },
  {
    name: "Maximum Total Payout for Card",
    render: row => formatCurrencyWithRands(row.maximum_total_payout)
  },
  {
    name: "Minimum Payment Amount",
    render: row => formatCurrencyWithRands(row.minimum_payment_amount)
  },
  {
    name: "User Limit Type",
    render: row => (row.user_limit_type ? row.user_limit_type : "N/A")
  },
  {
    name: "User Limit Amount",
    render: row => formatCurrencyWithRands(row.user_limit_amount)
  },
  {
    name: "Strategy Limit Amount",
    render: row => formatCurrencyWithRands(row.strategy_limit_amount)
  }
];

export default columnConfigs;
